import React from 'react';

const EmptyBoxContent = ({ icon, title, content, btn1Text, btn2Text, btn1Href = null, btn2Href = null, btn1OnClick, btn2OnClick }) => {
    return (
        <div className="box is-empty has-text-centered">
            <i className={icon}></i>

            <p className="title is-4">{title}</p>

            <p>{content}</p>

            <div className="buttons is-centered">
                <a className="button is-light" href={btn1Href} onClick={btn1OnClick}>{btn1Text}</a>
                <a className="button is-info" href={btn2Href} onClick={btn2OnClick}>{btn2Text}</a>
            </div>
        </div>
    );
}

export default EmptyBoxContent;